import { useEffect, useState, useCallback } from "react";
import { api } from "./config";

const DEFAULT = {
  maintenance_mode: false,
  maintenance_title: "",
  maintenance_message: "",
  maintenance_eta: "",
};

let _cache = null;
const _listeners = new Set();

async function fetchSettings() {
  try {
    const { data } = await api.get("/settings");
    _cache = data;
    _listeners.forEach((fn) => fn(data));
    return data;
  } catch {
    return _cache || DEFAULT;
  }
}

export function refreshSettings() {
  return fetchSettings();
}

export function useSettings({ poll = false } = {}) {
  const [settings, setSettings] = useState(_cache || DEFAULT);
  const [loading, setLoading] = useState(!_cache);

  const refresh = useCallback(async () => {
    const s = await fetchSettings();
    setSettings(s);
    setLoading(false);
    return s;
  }, []);

  useEffect(() => {
    refresh();
    _listeners.add(setSettings);
    let iv;
    if (poll) iv = setInterval(refresh, 30_000);
    return () => {
      _listeners.delete(setSettings);
      if (iv) clearInterval(iv);
    };
  }, [refresh, poll]);

  return { settings, loading, refresh };
}
